import { HttpClient } from '@angular/common/http';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { CommonModule } from '@angular/common';
import { UntypedFormControl, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ApiService } from 'src/app/services/api.service';
import { AppSettings } from 'src/app/services/AppSettings';
import { UtilService } from 'src/app/services/util.service';
import Swal from 'sweetalert2';
import { SearchListComponent } from './../../search-list/search-list.component';
import { UserCardComponent } from '../../cards/user-card/user-card.component';
import { WidgetModule } from '../../../widget/widget.module';
import { NG_ICON_DIRECTIVES } from '@ng-icons/core';
import { CommonSkeletonComponent } from 'src/app/skeleton/common-skeleton/common-skeleton.component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { NodataFoundComponent } from 'src/app/widget/nodata-found/nodata-found.component';


@Component({
  selector: 'app-people',
  standalone: true,
  imports: [BsDropdownModule, CommonModule, ReactiveFormsModule, FormsModule,
UserCardComponent, WidgetModule,
    NG_ICON_DIRECTIVES, CommonSkeletonComponent, InfiniteScrollModule,
    NodataFoundComponent,
  ],
  templateUrl: './people.component.html',
  styleUrls: ['./people.component.scss']
})
export class PeopleComponent implements OnInit, OnDestroy {


//   Alldata;

//   notscrolly = true;
//   notEmptyPost = true;
//   peopleData: string[];
//   photoId: any;
//   users;
//   communityPages;
//   offsetvalue;
//  count =0;
selColor: string;


   term;
   connected: boolean = false
   notConnected: boolean = false

//   title:string = "People"
//   Arraylength



  isAdmin
  photoId: any;


  constructor(
    private API: ApiService,
    private spinner: NgxSpinnerService,
    private serachComponent:SearchListComponent,
    private http: HttpClient,
    private router: Router ,
    private route: ActivatedRoute,
   private util: UtilService,
  ) {

  }
  colors: Array<any> = ['hgreen', 'hred', 'horange', 'hyellow'];

  randomColor(): void {
    this.selColor = this.colors[Math.floor(Math.random() * this.colors.length)];
  }


  connetedstatus(data){

  }

  removedata(data){

  }

  sendmsg(data){
    var userData: any= {}
    userData.userid  = data.userId
    this.router.navigate(['message'], {queryParams : userData})
 }



allpost: any[] = [];

userData = true;
userData1 = false;

// Inline skeleton grid while a results fetch is in flight (replaces the global
// spinner for these loads).
isLoading = false;
loaderCards = new Array(6);

// Window infinite scroll with OFFSET paging. The cursor form this replaced sent
// the last card's sort values back, and the first of those is the relevance score
// - a float that travels as a JSON number and returns as a double that is not
// bit-for-bit the original. Rows sharing the cursor's score were then served
// again, so a page could repeat the whole group it ended on and the list ran past
// its own total with duplicates. An offset is an integer, nothing to round.
pageSize = 15;
userTotalCount = 0;
/** Rows the server has sent for the current search, which is what the next
 *  request offsets by. Kept separate from allpost.length because duplicates are
 *  now discarded on append. */
private receivedCount = 0;
endReached = false;
isLoadingMore = false;
loadMoreCards = new Array(3);
// The text the current list was fetched with (route term or the page's own
// search box), so scrolling keeps paging the same result set.
activeSearch = '';

navaData;
  srarch;

selector: string = ".search-results";
// cls(){
//   ////// console.log('callback function ........s');
// };

lenght;
 /** Closed in ngOnDestroy so the queryParams subscription dies with the
  *  component. The tabs are swapped with *ngIf, so leaving it open kept every
  *  previously-mounted instance alive and re-running its own search on the next
  *  param change - extra in-flight calls the visible component's isLoadingMore
  *  guard cannot see, because that flag is per instance. */
 private readonly destroy$ = new Subject<void>();

 ngOnDestroy(): void {
   this.destroy$.next();
   this.destroy$.complete();
 }

 ngOnInit() {
   this.route.queryParams.pipe(takeUntil(this.destroy$)).subscribe((data) =>{
     ////// console.log('People data : ', data);
     this.navaData = data.data;
     // Trimmed on the way in too: the nav bar already trims, but a bookmarked or
     // hand-edited URL can still carry a whitespace-only searchData.
     this.srarch = (data.searchData ?? '').trim();

     this.term = this.srarch
   })
   if(this.navaData != 'undefined' && this.srarch != 'undefined'){

    this.loadInitPost();
  }else{
    this.loadInitPost();
  }
  //  ////// console.log('this.navaData !=  && this.srarch != ', this.navaData ,this.srarch)
  //  if(this.navaData != 'undefined' && this.srarch != 'undefined'){
  //   // this.loadInitPost();
  //   this.loadUserData();
  //  }else {
  //   //  this.loadUserData();
  //   this.loadInitPost();
  //  }

}

loadInitPost() {
  this.activeSearch = this.srarch;
  this.fetchPage(this.pageSize, true);
}

get hasMore(): boolean {
  // Measured against rows RECEIVED, not rows kept: a page discarded entirely as
  // duplicate still consumed its slice of the total, and testing the kept length
  // would leave hasMore permanently true.
  return !this.endReached && this.receivedCount < this.userTotalCount;
}

/**
 * Append `incoming` to `existing`, skipping any row whose id is already on
 * screen. Two requests in flight at once return overlapping slices and the
 * server re-ranks between them, so `concat` rendered the same card twice.
 * Rows with no id are kept - they cannot be compared, and dropping them would
 * lose data rather than a duplicate.
 */
private appendUnique(existing: any[], incoming: any[], idKey: string): any[] {
  if (!incoming || incoming.length === 0) {
    return existing;
  }
  const seen = new Set((existing || []).map(row => row?.[idKey]).filter(id => id != null));
  const fresh = incoming.filter(row => {
    const id = row?.[idKey];
    if (id == null) { return true; }
    if (seen.has(id)) { return false; }
    seen.add(id);
    return true;
  });
  return fresh.length ? (existing || []).concat(fresh) : (existing || []);
}

// One request against /home/profiles/search. reset=true starts from the top
// (first page / new search) and replaces the list, otherwise the page after
// the current key is appended.
private fetchPage(pageCount: number, reset: boolean) {
  // Rows RECEIVED so far IS the offset for the next block. This cannot be
  // allpost.length any more: the append below drops rows already on screen, so a
  // fully duplicated page would leave the length unchanged, the next request
  // would ask for the same offset, and the feed would loop on one page for ever.
  const offSet = reset ? 0 : this.receivedCount;
  const data = {'search': this.activeSearch,
    'searchContent': 'ALL',
    'loginUserId':localStorage.getItem('userId'),
    'page': {
            'offSet': offSet,
            'pageCount': pageCount
            }
    };
  if (reset) {
    this.isLoading = true;
    this.endReached = false;
  } else {
    this.isLoadingMore = true;
  }
  this.API.create('home/profiles/search' , data).subscribe(res => {
    this.isLoading = false;
    this.isLoadingMore = false;
    const users = (res && Array.isArray(res.users)) ? res.users : [];
    users.forEach(element => {
      element.userImage = element.photo ? AppSettings.photoUrl + element.photo : null;
      element.userColor = this.colors[Math.floor(Math.random() * this.colors.length)];
    });
    if (users.length === 0) {
      this.endReached = true;
    }
    this.userTotalCount = res?.page?.userTotalCount ?? users.length;
    this.receivedCount = offSet + users.length;
    this.allpost = reset ? users : this.appendUnique(this.allpost, users, 'userId');
    this.lenght = this.allpost.length;
    this.fillViewportIfNeeded();
  }, err => {
    this.isLoading = false;
    this.isLoadingMore = false;
  });
}

// Fires from the infiniteScroll directive when the window nears the bottom.
onScroll() {
  if (this.isLoading || this.isLoadingMore || !this.hasMore) {
    return;
  }
  this.fetchPage(this.pageSize, false);
}

// On a tall screen one page may not produce a scrollbar, and without a scroll
// event the directive never fires. After each page renders, pull the next one
// while the document is still shorter than the window.
private fillViewportIfNeeded() {
  setTimeout(() => {
    if (this.hasMore && document.documentElement.scrollHeight <= window.innerHeight + 50) {
      this.onScroll();
    }
  }, 0);
}

// After a card action (connect / cancel) refetch everything already on
// screen in one request so the user keeps their place instead of dropping
// back to the first page. The returned key then continues from the last card.
private refreshLoaded() {
  this.fetchPage(Math.max(this.pageSize, this.allpost.length), true);
}

loadUserData(){
  const data = {'search': this.srarch,
    'searchContent':'ALL',
    // 'searchContent': 'USER',
    'loginUserId':localStorage.getItem('userId'),
    'page': {
            'offSet': 0,
            'pageCount': 50
            }
    };
 this.util.startLoader()
 this.API.create('home/profiles/searchAll' , data).subscribe(data => {
   this.util.stopLoader()
   ////// console.log("user data 2:",data.users);
   this.allpost = data.users;
   this.lenght = data.users.length;
   ////// console.log(this.lenght);
  },err => {
    this.util.stopLoader();

   });

}
clearInput = new UntypedFormControl();

clearData(){
  this.clearInput.reset();
////// console.log('cleare Data')
}

peopleData(user){

  this.userData = false;
  this.userData1 = true;

  // Spaces are not a term. Trimming turns "   " back into "" - the same state the
  // box was already in - so the equality check below drops the keystroke instead
  // of refetching the whole list for whitespace.
  const term = (this.clearInput.value ?? '').trim();
  if (term === this.activeSearch) {
    return;
  }
  this.activeSearch = term;
  this.fetchPage(this.pageSize, true);
}

connect(data){
  ////// console.log('connect data:' ,data)
  data.requestedBy = localStorage.getItem('userId')
  // this.util.startLoader()
  this.API.create('user/connect', data).subscribe(res=>{
    ////// console.log('connect data :' , res)
    // this.util.stopLoader()
    if(res.code=="00000"){

      if(res.message === "Connect request sent successfully"){
        this.notConnected = true
      }
      // Was this.ngOnInit(). Calling a lifecycle hook by hand re-ran the whole
      // initialiser, and its route.queryParams.subscribe added ANOTHER live
      // subscription every time - so after N connects, one param change fired
      // N+1 parallel searches whose overlapping pages rendered as duplicate
      // cards. refreshLoaded() re-reads the rows already on screen, which is all
      // this needed.
      this.refreshLoaded()
      //message to show connect request is sent successfully
      // this.requestSent = true
      // this.notConnected = false
      // this.connected = false

      // if()
      // setTimeout(function(){ Swal.fire("Request has been sent Successfully!"); }, 200);
      Swal.fire({
        position: "center",
        icon: "success",
        title: "Request sent successfully",
        showConfirmButton: false,
        timer: 2000,
        });

    }else if(res.code=="88888"){
      // this.requestSent = false
      // this.notConnected = false
      // this.connected = false
    }
  },err => {
    this.util.stopLoader();

   });

}
handleUserCardEvent(data: any): void {
  this.refreshLoaded();
}
cancelConnectionRequest(data){
  ////// console.log('Cancel Connection Data', data)
  //  data.userId = localStorage.getItem('userId')
   ////// console.log('connData.userId',data.userId)
  this.util.startLoader()
  this.API.create('user/connect/cancel',data).subscribe(res =>{
    this.util.stopLoader()
    ////// console.log('Cancel Connection : ', res);
    if(res.code === '00000'){
      ////// console.log('Connect request cancelled successfully');
      // setTimeout(function(){ Swal.fire("Request has been sent Successfully!"); }, 200);
      // this.user.connectionStatus="NOT_CONNECTED";
      // this.initCard();
      // this.requestSent = false
      // this.notConnected = true
      // this.connected = false
      // Was this.ngOnInit() - see the note on the connect path above; it stacked
      // one extra queryParams subscription per cancel.
      this.refreshLoaded()
    }else if(res.code === '88888'){
      ////// console.log('Unable to Cancel connection');
    }
  },err => {
    this.util.stopLoader();

   });

}
dynamicdata(arg0: string, dynamicdata: any) {
  throw new Error("Method not implemented.");
}





}


